import React, { useContext } from "react";
import { PartyInvitationCardContext, Skeleton } from "./context";
import NormalAvatar from "../Common/NormalAvatar";
import { WEBSITE_URL } from "~/src/utils/common";

export function InvitationAvatar({ compact = false }): React.ReactElement {
  const { avatarImage, isRendering = true } = useContext(
    PartyInvitationCardContext
  );
  const size = compact ? 60 : 150;
  const hasAvatar = Boolean(avatarImage);
  if (isRendering) {
    return (
      <Skeleton
        width={size}
        height={size}
        borderRadius={999}
        className="border border-primary"
      />
    );
  }
  return (
    <img
      src={
        hasAvatar ? avatarImage : `${WEBSITE_URL}/static/party-chat-avatar.svg`
      }
      alt={
        avatarImage
          ? compact
            ? "avatar"
            : "Avatar"
          : compact
            ? "avatar-default"
            : "Avatar default"
      }
      loading="eager"
      fetchPriority="high"
      decoding="async"
      className={
        avatarImage
          ? "size-full object-cover rounded-full border border-primary"
          : "size-full object-contain"
      }
    />
  );
}

export function InvitationOwnerAvatar({ compact = false }): React.ReactElement {
  const {
    ownerNFTImage = "",
    ownerAvatarImage = "",
    walletAddress = "",
  } = useContext(PartyInvitationCardContext);
  const size = compact ? 24 : 32;
  return ownerNFTImage?.length > 0 ? (
    <div
      className="w-full flex justify-center items-center shadow-common custom-polygon bg-primary"
      style={{ height: size, width: size }}
    >
      <img
        src={ownerNFTImage}
        alt={compact ? "avatar" : "Avatar"}
        loading="lazy"
        decoding="async"
        className="size-full object-contain"
      />
    </div>
  ) : (
    <NormalAvatar
      url={ownerAvatarImage}
      width={size}
      height={size}
      walletAddress={walletAddress}
    />
  );
}
